import store from '@/store';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/views/dashboard/Dashboard';

// PROFILE //
import ProfileBase from '@/views/profile/ProfileBase';
import Profile from '@/views/profile/Profile';
import MyTasks from '@/views/tasks/MyTasks';
import ChangePassword from '@/views/profile/ChangePassword';

// AUTH //
import Login from '@/views/Login'
import Logout from '@/views/Logout'
import ForgotPassword from '@/views/ForgotPassword'
import NoAccess from '@/views/NoAccess'

// MODULES //
import accountingRoutes from '@/modules/accounting/router';
import assetsRoutes from '@/modules/assets/router';
import clientsRoutes from '@/modules/clients/router';
import estimateRoutes from '@/modules/estimates/router';
import projectRoutes from '@/modules/projects/router';
import wosRoutes from '@/modules/wos/router';
import scheduleRoutes from '@/modules/schedule/router';
import staffingRoutes from '@/modules/staffing/router';
import snowTrackerRoutes from '@/modules/snowTracker/router';
import fieldcrewsRoutes from '@/modules/fieldcrews/router';
import settingsRoutes from '@/modules/settings/router';
import managementRoutes from '@/modules/management/router';
import timesheetRoutes from '@/modules/timesheets/router';
import payrollRoutes from '@/modules/payroll/router';
import inquiriesRoutes from '@/modules/inquiries/router';
import softwareRoutes from '@/modules/software/router';
import constructionRoutes from '@/modules/construction/router';
import noticesRoutes from '@/modules/notices/router';
import tasksRoutes from '@/modules/tasks/router';
import stagingRoutes from './staging';

Vue.use(VueRouter)

const mainRoutes = [
  {
    path: '/',
    redirect: { name: 'Dashboard' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: (to, from, next) => {
      store.dispatch('clearSubnav')
      next()
    }
  },
  {
    path: '/profile',
    component: ProfileBase,
    beforeEnter: (to, from, next) => {
      store.dispatch('clearMainMenu')
      store.dispatch('clearSubnav')
      next()
    },
    children: [
      {
        path: 'details',
        name: 'Profile',
        component: Profile
      },
      {
        path: 'my-tasks',
        name: 'MyTasks',
        component: MyTasks
      },
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: ChangePassword
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/no-access',
    name: 'NoAccess',
    component: NoAccess
  }
]

var emptyRoutes = []
var routes = emptyRoutes.concat(
  mainRoutes,
  accountingRoutes,
  assetsRoutes,
  clientsRoutes,
  estimateRoutes,
  projectRoutes,
  wosRoutes,
  scheduleRoutes,
  staffingRoutes,
  snowTrackerRoutes,
  fieldcrewsRoutes,
  settingsRoutes,
  managementRoutes,
  timesheetRoutes,
  payrollRoutes,
  inquiriesRoutes,
  softwareRoutes,
  constructionRoutes,
  noticesRoutes,
  tasksRoutes,
  stagingRoutes
)

const router = new VueRouter({
  routes
})

export default router
